module.exports = __webpack_public_path__ + "img/button_Plus.66f013a5.svg";